<template>
    <b-container class="support-form">
        <b-row>
            <b-col>
                <b-form class="ticket">
                    <b-form-group label="Area">
                        <b-form-select
                                id="tag"
                                class="form-control"
                                v-bind:class="{ error: error.tag }"
                                v-model="ticket.tag"
                                required="required"
                        >
                            <b-form-select-option value="" disabled>{{$t('user.support.ticket.placeholder.tag')}}</b-form-select-option>
                            <b-form-select-option v-for="(option, index) in options" v-bind:key="index" v-bind:value="option.value">{{option.text}}</b-form-select-option>
                        </b-form-select>
                        <p class="error" v-show="error.text">{{$t('user.support.ticket.error.tag')}}</p>
                    </b-form-group>

                    <b-form-group label="Title">
                        <input
                                id="title"
                                class="form-control"
                                v-bind:class="{ error: error.title }"
                                v-model="ticket.title"
                                placeholder="Title of your support request"
                                required="required"
                        />
                        <p class="error" v-show="error.text">{{$t('user.support.ticket.error.title')}}</p>
                    </b-form-group>
                    <b-form-group label="Message">
                          <textarea
                                  id="text"
                                  class="form-control"
                                  v-bind:class="{ error: error.text }"
                                  v-model="ticket.text"
                                  placeholder="Enter your message"
                                  rows="5"
                                  required="required"
                          ></textarea>
                          <p class="error" v-show="error.text">{{$t('user.support.ticket.error.text')}}</p>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
      <hr/>
        <b-row align-h="end" class="contentcontainer__footer">
          <b-col cols="auto">
            <button class="btn btn--success" v-on:click="submitForm()">{{$t('user.support.submitticket')}}</button>
          </b-col>
          <b-col cols="auto">
            <button class="btn btn--danger" v-on:click="closeForm()">{{$t('user.support.cancelticket')}}</button>
          </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {

  name: 'SupportForm',

  computed: {
    ...mapState('support', [
      'tags'
    ]),

    options () {
      const result = []
      this.tags.forEach((element) => {
        result.push({
          value: element.id,
          text: element.name
        })
      })

      return result
    }

  },

  data () {
    return {
      ticket: {
        title: '',
        tag: '',
        text: ''
      },
      error: {
        title: '',
        tag: '',
        text: ''
      }

    }
  },

  methods: {

    ...mapMutations('support', [
      'showSupportNewTicketForm',
      'closeSupportNewTicketForm'
    ]),

    ...mapActions('support', [
      'create',
      'getTickets'
    ]),

    preparePage (data) {

    },

    closeForm () {
      this.error.tag = false
      this.error.text = false
      this.error.title = false
      this.closeSupportNewTicketForm()
    },

    submitForm () {
      // Check form
      this.error.tag = false
      this.error.text = false
      this.error.title = false
      let formFailed = false

      if (this.ticket.tag === '') {
        this.error.tag = true
        formFailed = true
      }

      if (this.ticket.text === '') {
        this.error.text = true
        formFailed = true
      }

      if (this.ticket.title === '') {
        this.error.title = true
        formFailed = true
      }

      if (formFailed) {
        return
      }

      const payload = {
        tag_id: this.ticket.tag,
        title: this.ticket.title,
        text: this.ticket.text
      }

      this.create(payload).then(() => {
        // Reset data set
        this.ticket = {
          title: '',
          tag: '',
          text: ''
        }

        this.getTickets()
        this.closeSupportNewTicketForm()
      })
    }
  }

}
</script>
